import { __awaiter, __decorate, __metadata } from "tslib";
import { Mutation, Action, VuexModule, Module } from 'vuex-module-decorators';
import { Mutations } from '@/store/enums/pscm/migo/transactionListEnums';
import ApiService from '@/core/services/ApiService';
let popupMasterModule = class popupMasterModule extends VuexModule {
    constructor() {
        super(...arguments);
        this.addNewSloc = false;
        this.addNewMovement = false;
        this.filterSloc = false;
        this.filterMovement = false;
        this.listArraySloc = [];
        this.listArrayMovementType = [];
        this.lkupUserGroupSloc = {
            addNew: [],
            filter: []
        };
        this.lkupUserGroupMvtype = {
            addNew: [],
            filter: []
        };
        this.lkupSloc = {
            addNew: [],
            filter: []
        };
        this.lkupMvtype = {
            addNew: [],
            filter: []
        };
        this.lkupSpecialStock = {
            addNew: [],
            filter: []
        };
        this.slocFilterTips = [];
        this.movementFilterTips = [];
        this.filterFormSloc = {
            usergroup: null,
            sloc: null
        };
        this.filterFormMovement = {
            usergroup: null,
            specialstock: null,
            mvtype: null
        };
        this.listError = {
            sloc: [],
            mvType: []
        };
        this.slocForm = {
            groupId: null,
            slocCode: null
        };
        this.mvTypeForm = {
            mvtTypeCode: null,
            mvtTypeDesc: null,
            specialStock: null,
            groupId: null
        };
        this.masterDataForm = {};
    }
    get getMasterDataFormMigo() {
        return this.masterDataForm;
    }
    get getAddNewSloc() {
        return this.addNewSloc;
    }
    get getAddNewMovement() {
        return this.addNewMovement;
    }
    get getFilterSloc() {
        return this.filterSloc;
    }
    get getFilterMovement() {
        return this.filterMovement;
    }
    get getListErrorSloc() {
        return this.listError.sloc;
    }
    get getListErrorMvType() {
        return this.listError.mvType;
    }
    get getSlocForm() {
        return this.slocForm;
    }
    get getMvTypeForm() {
        return this.mvTypeForm;
    }
    get getFilterFormSloc() {
        return this.filterFormSloc;
    }
    get getFilterFormMovement() {
        return this.filterFormMovement;
    }
    get getSlocFilterTips() {
        return this.slocFilterTips;
    }
    get getMovementFilterTips() {
        return this.movementFilterTips;
    }
    get getLkupUserGroupSloc() {
        return this.lkupUserGroupSloc;
    }
    get getLkupUserGroupMvtype() {
        return this.lkupUserGroupMvtype;
    }
    get getLkupSloc() {
        return this.lkupSloc;
    }
    get getLkupMvtype() {
        return this.lkupMvtype;
    }
    get getLkupSpecialStock() {
        return this.lkupSpecialStock;
    }
    ['setMasterDataFormMigo'](data) {
        this.masterDataForm = data;
    }
    ['setLkupUserGroupSloc'](data) {
        this.lkupUserGroupSloc = data;
    }
    ['setLkupUserGroupMvtype'](data) {
        this.lkupUserGroupMvtype = data;
    }
    ['setLkupSloc'](data) {
        this.lkupSloc = data;
    }
    ['setLkupMvtype'](data) {
        this.lkupMvtype = data;
    }
    ['setLkupSpecialStock'](data) {
        this.lkupSpecialStock = data;
    }
    ['setAddNewSloc'](data) {
        this.addNewSloc = data;
    }
    ['setAddNewMovement'](data) {
        this.addNewMovement = data;
    }
    ['setFilterSloc'](data) {
        this.filterSloc = data;
    }
    ['setFilterMovement'](data) {
        this.filterMovement = data;
    }
    ['setSlocFilterTips'](data) {
        this.slocFilterTips = data;
    }
    ['setMovementFilterTips'](data) {
        this.movementFilterTips = data;
    }
    ['deleteSlocFilterTips'](params) {
        const index = this.slocFilterTips
            .map((x) => {
            return x.keyName;
        })
            .indexOf(params);
        this.slocFilterTips.splice(index, 1);
        this.filterFormSloc[params] = null;
    }
    ['deleteMovementFilterTips'](params) {
        const index = this.movementFilterTips
            .map((x) => {
            return x.keyName;
        })
            .indexOf(params);
        this.movementFilterTips.splice(index, 1);
        this.filterFormMovement[params] = null;
    }
    ['setSlocForm'](data) {
        this.slocForm = data;
    }
    ['resetSlocForm']() {
        this.slocForm.groupId = null;
        this.slocForm.slocCode = null;
        this.slocFilterTips = [];
        this.filterFormSloc = {
            usergroup: null,
            sloc: null
        };
        this.masterDataForm = {};
    }
    ['setMvTypeForm'](data) {
        this.mvTypeForm = data;
    }
    ['resetMvTypeForm']() {
        this.mvTypeForm.mvtTypeCode = null;
        this.mvTypeForm.mvtTypeDesc = null;
        this.mvTypeForm.specialStock = null;
        this.mvTypeForm.groupId = null;
        this.movementFilterTips = [];
        this.filterFormMovement = {
            usergroup: null,
            specialstock: null,
            mvtype: null
        };
        this.masterDataForm = {};
    }
    ['setListErrorSloc'](data) {
        this.listError.sloc = data;
    }
    ['setListErrorMvType'](data) {
        this.listError.mvType = data;
    }
    ['getLookUpPopupMigo']({ paramsApiUrl, payloadParams, conditions: { state, type } }) {
        return __awaiter(this, void 0, void 0, function* () {
            const apiUrl = `${process.env.VUE_APP_BASE_URL_DIGITAL}/pscm-migo/api/` + paramsApiUrl;
            return yield new Promise((resolve, reject) => {
                if (state === 'transferposting' && type === 'transactionType') {
                    ApiService.getData(apiUrl)
                        .then((response) => {
                        const data = response.data.result.content;
                        const res = response.data.result;
                        if (res.isError) {
                            this.context.commit('setErrorHandlerMigo', res);
                            resolve();
                        }
                        else {
                            if (state == 'transferposting') {
                                const obj = {
                                    obj: type,
                                    data: data
                                };
                                this.context.commit('setTpLookup', obj);
                            }
                            else if (state == 'transactionListGi') {
                                const obj = {
                                    obj: type,
                                    data: data
                                };
                                this.context.commit(Mutations.SET_LOOKUPS_FILTER_GI, obj);
                            }
                            resolve();
                        }
                    })
                        .catch((error) => {
                        if (error.response) {
                            const obj = {
                                statusCode: error.response.status
                            };
                            this.context.commit('setErrorHandlerMigo', obj);
                            reject(error);
                        }
                        else {
                            reject(error);
                        }
                    });
                }
                else {
                    ApiService.post(apiUrl, payloadParams)
                        .then((response) => {
                        const data = response.data.result.content;
                        const res = response.data.result;
                        if (res.isError) {
                            this.context.commit('setErrorHandlerMigo', res);
                            resolve();
                        }
                        else {
                            if (state == 'new') {
                                switch (type) {
                                    case 'sloc':
                                        switch (payloadParams.lookupKey) {
                                            case 'USERGROUP':
                                                this.context.commit('setLkupUserGroupSloc', {
                                                    addNew: data,
                                                    filter: this.lkupUserGroupSloc.filter
                                                });
                                                break;
                                            case 'SLOC':
                                                this.context.commit('setLkupSloc', {
                                                    addNew: data,
                                                    filter: this.lkupSloc.filter
                                                });
                                                break;
                                        }
                                        break;
                                    case 'slocuser':
                                        switch (payloadParams.lookupKey) {
                                            case 'USERGROUP':
                                                this.context.commit('setLkupUserGroupSloc', {
                                                    addNew: data,
                                                    filter: this.lkupUserGroupSloc.filter
                                                });
                                                break;
                                            case 'SLOCUSER':
                                                this.context.commit('setLkupSloc', {
                                                    addNew: data,
                                                    filter: this.lkupSloc.filter
                                                });
                                                break;
                                        }
                                        break;
                                    case 'mvtype':
                                        switch (payloadParams.lookupKey) {
                                            case 'USERGROUP':
                                                this.context.commit('setLkupUserGroupMvtype', {
                                                    addNew: data,
                                                    filter: this.getLkupUserGroupMvtype.filter
                                                });
                                                break;
                                            case 'MVTYPE':
                                                this.context.commit('setLkupMvtype', {
                                                    addNew: data,
                                                    filter: this.lkupMvtype.filter
                                                });
                                                break;
                                            case 'SPECIAL_STOCK':
                                                this.context.commit('setLkupSpecialStock', {
                                                    addNew: data,
                                                    filter: this.lkupSpecialStock.filter
                                                });
                                                break;
                                        }
                                        break;
                                }
                            }
                            else if (state == 'filter') {
                                switch (type) {
                                    case 'sloc':
                                        switch (payloadParams.lookupKey) {
                                            case 'USERGROUP':
                                                this.context.commit('setLkupUserGroupSloc', {
                                                    addNew: this.lkupUserGroupSloc.addNew,
                                                    filter: data
                                                });
                                                break;
                                            case 'SLOC':
                                                this.context.commit('setLkupSloc', {
                                                    addNew: this.lkupSloc.addNew,
                                                    filter: data
                                                });
                                                break;
                                        }
                                        break;
                                    case 'slocuser':
                                        switch (payloadParams.lookupKey) {
                                            case 'USERGROUP':
                                                this.context.commit('setLkupUserGroupSloc', {
                                                    addNew: this.lkupUserGroupSloc.addNew,
                                                    filter: data
                                                });
                                                break;
                                            case 'SLOCUSER':
                                                this.context.commit('setLkupSloc', {
                                                    addNew: this.lkupSloc.addNew,
                                                    filter: data
                                                });
                                                break;
                                        }
                                        break;
                                    case 'mvtype':
                                        switch (payloadParams.lookupKey) {
                                            case 'USERGROUP':
                                                this.context.commit('setLkupUserGroupMvtype', {
                                                    addNew: this.getLkupUserGroupMvtype.addNew,
                                                    filter: data
                                                });
                                                break;
                                            case 'MVTYPE':
                                                this.context.commit('setLkupMvtype', {
                                                    addNew: this.lkupMvtype.addNew,
                                                    filter: data
                                                });
                                                break;
                                            case 'SPECIAL_STOCK':
                                                this.context.commit('setLkupSpecialStock', {
                                                    addNew: this.lkupSpecialStock.addNew,
                                                    filter: data
                                                });
                                                break;
                                        }
                                        break;
                                }
                            }
                            else if (state == 'goodsreceipt') {
                                const obj = {
                                    obj: type,
                                    data: data
                                };
                                this.context.commit('setGrLookup', obj);
                            }
                            else if (state == 'grOther') {
                                const obj = {
                                    obj: type,
                                    data: data
                                };
                                this.context.commit('setGrOtherLookup', obj);
                            }
                            else if (state == 'transactionListGr') {
                                const obj = {
                                    obj: type,
                                    data: data
                                };
                                this.context.commit(Mutations.SET_LOOKUPS_FILTER_GR, obj);
                            }
                            else if (state == 'goodsIssue') {
                                const obj = {
                                    obj: type,
                                    data: data
                                };
                                this.context.commit('setGiLookup', obj);
                            }
                            else if (state == 'transferposting') {
                                const obj = {
                                    obj: type,
                                    data: data
                                };
                                this.context.commit('setTpLookup', obj);
                            }
                            else if (state == 'transactionListGi') {
                                const obj = {
                                    obj: type,
                                    data: data
                                };
                                this.context.commit(Mutations.SET_LOOKUPS_FILTER_GI, obj);
                            }
                            else if (state == 'transactionListTp') {
                                const obj = {
                                    obj: type,
                                    data: data
                                };
                                this.context.commit(Mutations.SET_LOOKUPS_FILTER_TP, obj);
                            }
                            resolve();
                        }
                    })
                        .catch((error) => {
                        if (error.response) {
                            const obj = {
                                statusCode: error.response.status
                            };
                            this.context.commit('setErrorHandlerMigo', obj);
                            reject(error);
                        }
                        else {
                            const obj = {
                                message: error
                            };
                            this.context.commit('setErrorHandlerMigo', obj);
                            reject(error);
                        }
                    });
                }
            });
        });
    }
    ['submitAddNewMaster']({ params, type }) {
        return __awaiter(this, void 0, void 0, function* () {
            const listUrl = {
                sloc: '/pscm-migo/api/master/sloc/upsert?ver=v1',
                mvType: '/pscm-migo/api/master/mvtype/upsert?ver=v1'
            };
            const resetName = {
                sloc: 'resetSlocForm',
                mvType: 'resetMvTypeForm'
            };
            const listErrorName = {
                sloc: 'sloc',
                mvType: 'mvType'
            };
            const apiUrl = `${process.env.VUE_APP_BASE_URL_DIGITAL}${listUrl[type]}`;
            return yield new Promise((resolve) => {
                ApiService.post(apiUrl, params)
                    .then((response) => {
                    const res = response.data.result;
                    const contentRes = res.content;
                    if (!res.isError) {
                        this.context.commit(`${resetName[type]}`);
                        const obj = {
                            text: res.message
                        };
                        this.context.commit('setSuccessMigo', obj);
                    }
                    else {
                        this.listError[listErrorName[type]] = {};
                        const errorResult = [];
                        contentRes.errorSets.forEach((g) => {
                            const name = g.field.name;
                            const list = [];
                            g.errors.forEach((gs) => {
                                list.push(gs);
                            });
                            errorResult.push({ name, list });
                        });
                        this.listError[listErrorName[type]] = errorResult;
                    }
                    resolve(res);
                })
                    .catch((error) => {
                    this.context.commit('setErrorPop', {
                        show: true,
                        description: [error]
                    });
                });
            });
        });
    }
    get getListSloc() {
        return this.listArraySloc;
    }
    ['setListSloc'](data) {
        this.listArraySloc = data;
    }
    ['getListSlocModule'](params) {
        return __awaiter(this, void 0, void 0, function* () {
            const apiUrl = `${process.env.VUE_APP_BASE_URL_DIGITAL}/pscm-migo/api/master/sloc/multifilter?ver=v1`;
            const parameter = {
                pagingParameter: {
                    pageNumber: params.page,
                    pageSize: params.pageSize,
                    orderColumn: params.orderColumn,
                    orderDir: params.orderDir
                },
                userLogin: String(params.employeeId),
                pageFilter: params.pageFilter
            };
            return yield new Promise((resolve, reject) => {
                ApiService.post(apiUrl, parameter)
                    .then((response) => {
                    const axiosResponse = response.data.result.content;
                    const listSloc = axiosResponse;
                    this.context.commit('setListSloc', listSloc);
                    this.context.commit('setIsLoading', false);
                    resolve();
                })
                    .catch((error) => {
                    this.context.commit('setErrorHandlerMigo', error.response.data);
                    reject(error);
                });
            });
        });
    }
    get getListMovementType() {
        return this.listArrayMovementType;
    }
    ['setListMovementType'](data) {
        this.listArrayMovementType = data;
    }
    ['getListMovementTypeModule'](params) {
        return __awaiter(this, void 0, void 0, function* () {
            const apiUrl = `${process.env.VUE_APP_BASE_URL_DIGITAL}/pscm-migo/api/master/mvtype/multifilter?ver=v1`;
            const parameter = {
                pagingParameter: {
                    pageNumber: params.page,
                    pageSize: params.pageSize,
                    orderColumn: params.orderColumn,
                    orderDir: params.orderDir
                },
                userLogin: String(params.employeeId),
                pageFilter: params.pageFilter
            };
            return yield new Promise((resolve, reject) => {
                ApiService.post(apiUrl, parameter)
                    .then((response) => {
                    const axiosResponse = response.data.result.content;
                    const listMovementType = axiosResponse;
                    this.context.commit('setListMovementType', listMovementType);
                    this.context.commit('setIsLoading', false);
                    resolve();
                })
                    .catch((error) => {
                    this.context.commit('setErrorHandlerMigo', error.response.data);
                    reject(error);
                });
            });
        });
    }
    ['deleteItemMaster']({ params, type }) {
        return __awaiter(this, void 0, void 0, function* () {
            const apiUrl = `${process.env.VUE_APP_BASE_URL_DIGITAL}/pscm-migo/api/master/${type}/softdelete?id=` +
                params +
                '&&ver=v1';
            return yield new Promise((resolve, reject) => {
                ApiService.post(apiUrl, params)
                    .then((response) => {
                    const res = response.data.result;
                    const contentRes = res.content;
                    if (!res.isError) {
                        this.context.commit('setSuccessPop', true);
                        this.context.commit('setSuccessDelete', true);
                    }
                    else {
                        const errorResult = [];
                        contentRes.errorSets.forEach((g) => {
                            const name = g.field.name;
                            const list = [];
                            g.errors.forEach((gs) => {
                                list.push(gs);
                            });
                            errorResult.push({ name, list });
                        });
                    }
                    this.context.commit('setIsLoading', false);
                    resolve(res);
                })
                    .catch((error) => {
                    this.context.commit('setErrorHandlerMigo', error.response.data);
                    reject(error);
                });
            });
        });
    }
    ['downloadFileMaster']({ params, type }) {
        return __awaiter(this, void 0, void 0, function* () {
            const apiUrl = `${process.env.VUE_APP_BASE_URL_DIGITAL}/pscm-migo/api/master/download/excel?ver=v1`;
            const parameter = {
                pagingParameter: {
                    pageNumber: params.page,
                    pageSize: params.pageSize,
                    orderColumn: params.orderColumn,
                    orderDir: params.orderDir
                },
                pageFilter: params.pageFilter,
                masterType: type
            };
            return yield new Promise((resolve, reject) => {
                ApiService.postBlobFile(apiUrl, parameter)
                    .then((response) => {
                    const fileName = response.headers['content-disposition']
                        .split('; ')[1]
                        .split('=')[1];
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', fileName);
                    document.body.appendChild(link);
                    link.click();
                    resolve();
                })
                    .catch((error) => {
                    this.context.commit('setErrorHandlerMigo', error.response.data);
                    reject(error);
                });
            });
        });
    }
};
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], popupMasterModule.prototype, 'setMasterDataFormMigo', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], popupMasterModule.prototype, 'setLkupUserGroupSloc', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], popupMasterModule.prototype, 'setLkupUserGroupMvtype', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], popupMasterModule.prototype, 'setLkupSloc', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], popupMasterModule.prototype, 'setLkupMvtype', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], popupMasterModule.prototype, 'setLkupSpecialStock', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], popupMasterModule.prototype, 'setAddNewSloc', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], popupMasterModule.prototype, 'setAddNewMovement', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], popupMasterModule.prototype, 'setFilterSloc', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], popupMasterModule.prototype, 'setFilterMovement', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], popupMasterModule.prototype, 'setSlocFilterTips', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], popupMasterModule.prototype, 'setMovementFilterTips', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], popupMasterModule.prototype, 'deleteSlocFilterTips', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], popupMasterModule.prototype, 'deleteMovementFilterTips', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], popupMasterModule.prototype, 'setSlocForm', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], popupMasterModule.prototype, 'resetSlocForm', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], popupMasterModule.prototype, 'setMvTypeForm', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], popupMasterModule.prototype, 'resetMvTypeForm', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], popupMasterModule.prototype, 'setListErrorSloc', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], popupMasterModule.prototype, 'setListErrorMvType', null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], popupMasterModule.prototype, 'getLookUpPopupMigo', null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], popupMasterModule.prototype, 'submitAddNewMaster', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], popupMasterModule.prototype, 'setListSloc', null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], popupMasterModule.prototype, 'getListSlocModule', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], popupMasterModule.prototype, 'setListMovementType', null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], popupMasterModule.prototype, 'getListMovementTypeModule', null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], popupMasterModule.prototype, 'deleteItemMaster', null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], popupMasterModule.prototype, 'downloadFileMaster', null);
popupMasterModule = __decorate([
    Module
], popupMasterModule);
export default popupMasterModule;
